import { bubaClientAuth } from "./bubaClientAuth";
import { endpoints } from "./endpoints";

export const getTokenInfo = (token: string) => {
  return bubaClientAuth({
    validateStatus: status => status < 300 || status === 401,
    url: endpoints.tokenInfo(),
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};
